"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lens = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Lens = (props) => {
    const { fadeDurationInMs = 0, isActive, isPositionOutside, style: parentSpecifiedStyle } = props, rest = __rest(props, ["fadeDurationInMs", "isActive", "isPositionOutside", "style"]);
    const defaultStyle = {
        width: 'auto',
        height: 'auto',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        display: 'block',
    };
    const computedStyle = {
        position: 'absolute',
        opacity: (isActive && !isPositionOutside) ? 1 : 0,
        transition: `opacity ${fadeDurationInMs}ms ease-in`,
    };
    const compositStyle = Object.assign(Object.assign(Object.assign({}, defaultStyle), parentSpecifiedStyle), computedStyle);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ style: compositStyle }, rest));
};
exports.Lens = Lens;
//# sourceMappingURL=Lens.js.map